<template>
  <section>
    <!-- 美国用户实名 -->
    <verified-usa :appid="urlData.appid" :pid="urlData.pid" ref="verifiedUsa" />
    <!-- 用户协议弹窗 -->
    <protocol ref="protocol" @settled="handleProtocolSettled" />
    <div
      class="warp"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mwarp' : 'warp'"
      :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
    >
      <!-- pc header -->
      <div class="header" v-if="this.$Base.checkSysteam() !== 'MOBILE'">
        <div class="header-in" style="width: 1300px">
          <div class="head-left">
            <div class="vi-logo" v-if="this.$Base.langPicClass() == 'vi-VN'">
              <img src="../../assets/vi/logo.png" alt="" />
            </div>
            <div v-else class="logo">
              <img src="../../assets/logo.png" alt="" />
            </div>
            <ul class="header_nav">
              <li @click="goTopage(1)" v-if="downpwa">
                {{ $t("message.navigator_download") }}
              </li>
              <li @click="goTopage(2)">
                {{ $t("message.navigator_website") }}
              </li>
              <li @click="goTopage(3)">
                {{ $t("message.navigator_collect") }}
              </li>
              <li @click="goTopage(4)">
                <i v-if="newinfo"></i>{{ $t("message.navigator_service") }}
              </li>
              <li @click="goTopage(5)">{{ $t("message.navigator_teach") }}</li>
            </ul>
          </div>
          <div class="header_userinfo">
            <!-- 名字未登录显示登入 end -->
            <div class="user_avatar">
              <img src="../../assets/default.png" alt="" />
            </div>
            <!-- 名字登录显示 -->
            <p class="nickname">{{ personal.username }}</p>
            <div class="logoutLogin" @click="logoutLoginData">
              {{ $t("message.navigator_logout") }}
            </div>
          </div>
        </div>
      </div>
      <!-- wap header -->
      <!-- <div class="mheader" v-if="this.$Base.checkSysteam() == 'MOBILE'">
        
        <div class="logo">
          <img
            src="../../assets/logo.png"
            alt=""
          >
        </div>
      </div> -->
      <!-- <div class="menuBtn" @click="menuBtn()">
          <i v-if="newinfo"></i>
          <span></span>
          <span></span>
          <span></span>
      </div> -->
      <!-- 移动端侧边栏弹窗 -->
      <div class="popSide" v-show="logoutCloseBtn">
        <div class="popSide-in">
          <!-- 个人信息 -->
          <div class="header_userinfo">
            <!-- 名字未登录显示登入 end -->
            <div class="user_avatar">
              <img src="../../assets/default.png" alt="" />
            </div>
            <!-- 名字登录显示 -->
            <p class="nickname">{{ personal.username }}</p>
            <div class="logoutLogin" @click="logoutLoginData">
              {{ $t("message.navigator_logout") }}
            </div>
            <div class="logoutClose" @click="logoutClose"></div>
          </div>
          <!-- 侧边按钮 -->
          <ul class="header_nav">
            <!-- 下载APP -->
            <li
              class="nav-1"
              :class="'nav-1' + langClass"
              @click="appLoad()"
            ></li>
            <!-- 釘到桌面 -->
            <li
              class="nav-2"
              :class="'nav-2' + langClass"
              @click="desktop()"
            ></li>
            <!-- 客服 -->
            <li class="nav-3" :class="'nav-3' + langClass" @click="goTopage(4)">
              <i v-if="newinfo"></i>
            </li>
          </ul>
        </div>
      </div>
      <!-- 内容 游戏主体 -->
      <div
        class="game-iframe"
        :class="
          this.$Base.checkSysteam() == 'MOBILE' ? 'mgame-iframe' : 'game-iframe'
        "
        :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
      >
        <rastar-loading />
        <iframe
          :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
          :src="gameUrl"
          ref="gameIframe"
          id="ifra"
        ></iframe>
        <!-- <iframe :style="this.$Base.checkSysteam() == 'MOBILE'? GetWindowHeight:''" src="http://mxd.res.rastargames.com/webtest/maple.html?pid=397&appid=102493&md_id=200000&access_token=a623D8UnCXyEFTkOWp-HxM3yyGcjNrk8ZJlABxEhqY5iSPAeS9VM6UNSU1IA1GfEsHzDYvLsZX9Lk0b1YjEMqrzI8819kyHKFHmWsTbDMhQxEQuddks&deviceld=fdc41eeab39ec02de36b7f21ef304ffc" ref="gameIframe"></iframe> -->
      </div>
      <!-- 内容支付页面 -->
      <div
        class="game-iframe-pay"
        v-if="isPay"
        :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
        :class="
          this.$Base.checkSysteam() == 'MOBILE'
            ? 'mgame-iframe-pay'
            : 'game-iframe-pay'
        "
      >
        <iframe
          :src="payUrl"
          :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
        ></iframe>
        <div class="pay-colse-left" @click="payColse">x</div>
      </div>
      <!-- 客服内容 -->
      <div
        class="game-iframe-kefu"
        id="game-iframe-kefu"
        v-show="isKeFu"
        :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
        :class="
          this.$Base.checkSysteam() == 'MOBILE'
            ? 'mgame-iframe-kefu'
            : 'game-iframe-kefu'
        "
      >
        <iframe
          :src="kefuUrl"
          :style="this.$Base.checkSysteam() == 'MOBILE' ? GetWindowHeight : ''"
        ></iframe>
      </div>
      <!-- 弹窗收藏游戏 -->
      <div
        class="pop"
        v-if="isPop == 1"
        :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mpop' : 'pop'"
      >
        <div class="pop-content">
          <div class="collect" :class="langClass"></div>
          <div class="closeBtn" @click="close(1)"></div>
        </div>
      </div>
      <!-- 弹窗判断浏览器 -->
      <div class="pop" v-if="isPop == 2">
        <div class="pop-content">
          <div
            class="popEdge"
            :class="[
              this.$Base.checkSysteam() == 'MOBILE' ? 'mpopEdge' : 'popEdge',
              langClass,
            ]"
          ></div>
          <div class="closeBtn closeBtn1" @click="close(2)"></div>
          <div class="closeBtn closeBtn2" @click="close(2)"></div>
        </div>
      </div>
      <!-- 弹窗绑定邮箱 -->
      <div class="pop" v-if="isPop == 3">
        <div class="bingEmail">
          <div class="close" @click="close(3)"></div>
          <div class="logo"></div>
          <div class="title">{{ $t("message.bind_email") }}</div>
          <div class="inputBox">
            <div class="input-style">
              <input
                type="text"
                :placeholder="$t('message.input_bind_email')"
                class="user"
                v-model.trim="email"
                @click="focusEnd('Indexemail')"
                id="Indexemail"
              />
            </div>
            <div class="input-style">
              <input
                type="text"
                :placeholder="$t('message.enter_code')"
                class="user"
                v-model.trim="code"
                @click="focusEnd('IndexCode')"
                id="IndexCode"
              />
              <div v-show="show" @click="sendEmailCode" class="sendCode">
                {{ $t("message.get_code") }}
              </div>
              <div v-show="!show" class="sendCode">
                {{ count }}{{ $t("message.get_code_seconds") }}
              </div>
            </div>
          </div>
          <!-- 下一步按钮 -->
          <div
            class="sendBtn"
            :class="email && code ? 'active' : ''"
            @click="bindEmailBtn"
          >
            {{ $t("message.bind") }}
          </div>
        </div>
      </div>
      <!-- 引导提示 -->
      <div class="dialog" v-if="isDialog">
        <div class="close" @click="close('dialog')"></div>
        <img src="../../assets/dialog.png" />
      </div>
      <!-- 收藏/下载提示 -->
      <div class="getGift" v-if="isGetGift">
        <div class="close" @click="close('getGift')"></div>
        <img src="../../assets/getGift.gif" @click="showGift()" />
      </div>
      <!-- 二维码展示 -->
      <div class="QR" style="display: none">
        <div class="close" @click="close('QR')"></div>
        <img src="../../assets/QR.png" />
      </div>
      <!-- 弹窗复制礼包码 -->
      <div class="Gift" v-if="isGift">
        <div class="close" @click="close('Gift')"></div>
        <p class="p">{{ this.giftCode }}</p>
        <span
          ref="copy"
          :data-clipboard-text="this.giftCode"
          id="copy_text"
          @click="copy()"
        ></span>
      </div>
      <!-- 礼包码发放完毕 -->
      <div class="nullgift" v-if="isNullgift">
        <div class="close" @click="close('nullgift')"></div>
        <img src="../../assets/nullgift.png" />
      </div>
      <!-- 游戏操作说明 -->
      <div class="Instructions" style="display: none">
        <img src="../../assets/Instructions.png" />
      </div>
      <!-- 调起钉到桌面提示（iOS） -->
      <div class="pop" v-if="popIos">
        <div class="des_box">
          <div class="close" @click="close('popIosClose')"></div>
          <!-- <img src="../../assets/pop_ios.png" /> -->
          <div class="divIos" :class="langClass" id="divIos"></div>
        </div>
      </div>
      <!-- 调起钉到桌面提示（android）-->
      <div class="pop" v-if="popGoogle">
        <div class="des_box">
          <div class="close" @click="close('popGoogleClose')"></div>
          <!-- <img src="../../assets/pop_google.png" /> -->
          <div class="divGoogle" :class="langClass" id="divGoogle"></div>
        </div>
      </div>
      <!-- 底部 -->
      <rastar-footer v-if="system == 'PC'"></rastar-footer>
      <!-- 悬浮球 -->
      <rastar-ball :newinfo="newinfo" v-if="system == 'MOBILE'"></rastar-ball>
    </div>
  </section>
</template>

<script>
import Clipboard from "clipboard";
import rastarFooter from "../../components/footer/template.vue";
import rastarBall from "../../components/ball/template.vue";
import rastarLoading from "../../components/loading/template.vue";
import { RSSign } from "../../utils/sign";
import RastarSdk from "../../utils/rastarSdk";
import verifiedUsa from "../../components/verifiedUsa/index.vue";
import protocol from "../../components/protocol/index.vue";

export default {
  name: "game",
  components: {
    rastarFooter,
    rastarBall,
    rastarLoading,
    verifiedUsa,
    protocol,
  },
  data() {
    return {
      isNullgift: false,
      newinfo: false,
      isGift: false,
      giftCode: "",
      isDialog: false,
      isGetGift: false,
      downpwa: false,
      isPop: 0,
      personal: {},
      email: "",
      code: "",
      show: true,
      count: "",
      entryTime: 0,
      timer: null,
      gameUrl: "",
      isKeFu: false,
      isZhiFu: false,
      kefuUrl: "",
      uid: "",
      isPay: false,
      payUrl: "",
      isLoading: true,
      // 数据组信息
      dataCollecInfo: {
        uid: "",
        username: "",
      },
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
      kfApi: JSON.parse(this.$Storage.localStorageGet("kfApi")),
      XHUWEBSDK: this.$Storage.localStorageGet("_XH_U_WEBSDK"),
      showModuletime: "",
      logoutCloseBtn: false,
      isAndroid: false,
      isiOS: false,
      system: "",
      popIos: false,
      popGoogle: false,
      GetWindowHeight: {
        height: "",
      },
      langClass: "",
    };
  },
  // 生命周期 - 销毁完成
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 根绝不同语言添加class
    isActiveClass() {
      let lang = this.$Storage.localStorageGet("lang");
      if (lang.substring(0, 2) == "zh") {
        this.langClass = "ZH";
      } else if (lang.substring(0, 2) == "es") {
        this.langClass = "ES";
      } else {
        this.langClass = "EN";
      }
    },
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    getHeight() {
      // 获取浏览器高度，减去顶部导航栏的值70（可动态获取）,再减去head-DIV高度值80
      this.GetWindowHeight.height = window.innerHeight - 0 + "px";
      // alert(this.GetWindowHeight.height)
    },
    // menuBtn 展开侧边栏
    menuBtn() {
      this.$Report.webDotFather(
        this.urlData.pid,
        this.urlData.appid,
        this.urlData.ukey,
        "click_open_sidebar"
      );
      this.logoutCloseBtn = true;
      // 我点击当前的然后用一个值传回给
    },
    // 移动端关闭侧边栏
    logoutClose() {
      this.$Report.webDotFather(
        this.urlData.pid,
        this.urlData.appid,
        this.urlData.ukey,
        "click_close_sidebar"
      );
      this.logoutCloseBtn = false;
    },
    // 获取客服是否有新消息
    getNewinfo() {
      let serviceUinfo = this.$Storage.localStorageGet("serviceUinfo");
      console.log("serviceUinfo", serviceUinfo);
      let data = {
        language: this.$Storage.localStorageGet("serviceUinfo"),
        uinfo: serviceUinfo,
      };
      this.$SyModel.kfSync(this.kfApi.kf.notice_msg, data).then((res) => {
        if (res.code == 200) {
          this.newinfo = true;
        } else {
          this.newinfo = false;
        }
      });
    },
    showGift: function () {
      if (this.system === "PC") {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_pcldy_download_tips_receive"
        );
      } else {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_moldy_download_tips_receive"
        );
      }
      this.getgiftCode();
    },
    copy() {
      if (this.system === "PC") {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_pcldy_copy_gift_window_copy_gift"
        );
      } else {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_moldy_copy_gift_window_copy_gift"
        );
      }
      var clipboard = new Clipboard("#copy_text");
      clipboard.on("success", (e) => {
        console.log("複製成功！", e);
        this.$toast(this.$t.message.copy_success);
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        console.log("請手動複製", e);
        this.$toast(this.$t.message.copy_fail);
        // 释放内存
        clipboard.destroy();
      });
    },
    // 收藏是否是新注册进来
    isColl() {
      this.isPop = 1;
    },
    payColse() {
      this.isPay = false;
    },
    kefuColse() {
      this.isKeFu = false;
    },
    zhifuColse() {
      this.isZhiFu = false;
    },
    // 浏览器判断
    navigatorAAll() {
      var u = navigator.userAgent;
      // android终端
      this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // ios终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 是否为移动终端
      if (u.match(/AppleWebKit.*Mobile.*/)) {
        console.log("移动终端");
        // 判断是微信 、uc、QQ、Edg、Baidu、Firefox、Opera、Yandex、VivoBrowser 、华为
        if (
          u.match(/MicroMessenger/i) == "micromessenger" ||
          u.indexOf("UCBrowser") > -1 ||
          u.indexOf("MQQBrowser") > -1 ||
          u.indexOf("Baidu") > -1 ||
          u.indexOf("Yandex") > -1 ||
          u.indexOf("VivoBrowser") > -1 ||
          u.indexOf("HuaweiBrowser") > -1 ||
          u.indexOf("MiuiBrowser") > -1
        ) {
          this.isPop = 2;
        } else {
          console.log("谷歌内核");
        }
      } else {
        console.log("pc");
        if (u.indexOf("MSIE") >= 0) {
          this.isPop = 2;
        }
        //firefox
        // else if (u.indexOf("Firefox") >= 0) {
        //   this.isPop = 2;
        // }
        //Chrome
        else if (u.indexOf("Chrome") >= 0) {
          console.log("Chrome内核");
        }
        //Opera
        // else if (u.indexOf("Opera") >= 0) {
        //   this.isPop = 2;
        // }
        //Safari
        // else if (u.indexOf("Safari") >= 0) {
        //   this.isPop = 2;
        // }
        //Netscape
        else if (u.indexOf("Netscape") >= 0) {
          this.isPop = 2;
        }
      }
    },
    // app下载跳转
    appLoad() {
      this.$Report.webDotFather(
        this.urlData.pid,
        this.urlData.appid,
        this.urlData.ukey,
        "click_momsr_download"
      );
      if (this.isAndroid) {
        location.href = "https://fzggt.onelink.me/ygnt/ed300u2g";
      }
      if (this.isiOS) {
        location.href = "https://fzggt.onelink.me/ygnt/ed300u2g";
      }
    },
    handleProtocolSettled(info) {
      this.$refs.gameIframe.contentWindow.postMessage(
        {
          action: "onProtocolSettled",
          info,
        },
        "*"
      );
    },
    desktop() {
      this.logoutClose();
      this.$Report.webDotFather(
        this.urlData.pid,
        this.urlData.appid,
        this.urlData.ukey,
        "click_momsr_save_desktop"
      );
      if (this.isAndroid) {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "show_momsr_save_desktop_android"
        );
        this.popGoogle = true;
      }
      if (this.isiOS) {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "show_momsr_save_desktop_iOS"
        );
        this.popIos = true;
      }
    },
    // 关闭弹窗
    close(k) {
      this.$Storage.localStorageSet("show", "0");
      this.isPop = 0;
      if (k == 3) {
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_email_close"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_moldy_email_close"
          );
        }
      }
      if (k == "dialog") {
        clearInterval(this.showModuletime);
        this.isDialog = false;
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_pcldy_guide"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_moldy_pcldy_guide"
          );
        }
      }
      if (k == "getGift") {
        this.isGetGift = false;
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_pcldy_download_tips"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_moldy_download_tips"
          );
        }
      }
      if (k == "Gift") {
        this.isGift = false;
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_pcldy_copy_gift_window"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "close_moldy_copy_gift_window"
          );
        }
      }
      if (k == "nullgift") {
        this.isNullgift = false;
      }
      if (k == "popIosClose") {
        this.popIos = false;
      }
      if (k == "popGoogleClose") {
        this.popGoogle = false;
      }
    },
    // 跳转到对应的链接
    goTopage(k) {
      if (k == 1) {
        if (this.savePrompt) {
          this.savePrompt.prompt();
          this.savePrompt.userChoice.then((result) => {
            if (result.outcome == "dismissed") {
              console.log("用户拒绝安装");
            } else if (result.outcome == "accepted") {
              console.log("用户接受了安装");
            }
            console.log("安装平台" + result.platform);
          });
        }
        // 数据埋点
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_pcmsr_download"
        );
      } else if (k == 2) {
        // 越南PC端/移动端 跳转到枫之谷的官网地址
        let lang = this.$Storage.localStorageGet("lang");
        if (lang.substring(0, 2) == "en" || this.urlData.appid == "104293") {
          window.open("https://msrglobal.rastargames.com/", "_blank");
        } else {
          window.open("https://msrglobal.rastargames.com/", "_blank");
        }
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_pcmsr_web"
        );
      } else if (k == 3) {
        this.isPop = 1;
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_pcmsr_collect"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_moldy_collect"
          );
        }
      } else if (k == 4) {
        let isCache = this.$Storage.localStorageGet("deviceIdUa");
        if (!isCache) {
          // 不存在就强制刷新页面
          console.log("deviceIdUa isCache不存在");
          location.reload();
        } else {
          let lang = this.$Storage.localStorageGet("lang");
          // 印尼PC端/移动端的客服入口改成 跳转到枫之谷的印尼FB主页地址
          if (lang.substring(0, 2) == "id" || this.urlData.appid == "103321") {
            window.location.href = "https://www.facebook.com/ID.MapleStoryR/";
          } else {
            this.kfSync();
          }
          if (this.system === "PC") {
            this.$Report.webDotFather(
              this.urlData.pid,
              this.urlData.appid,
              this.urlData.ukey,
              "click_pcmsr_service"
            );
          } else {
            this.logoutClose();
            this.$Report.webDotFather(
              this.urlData.pid,
              this.urlData.appid,
              this.urlData.ukey,
              "click_momsr_service"
            );
          }
        }
      } else if (k == 5) {
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_pcldy_pay_teaching"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_moldy_pay_teaching"
          );
        }
        window.open(
          `/global/info?ukey=${this.urlData.ukey}&appid=${this.urlData.appid}&pid=${this.urlData.pid}&md_id=${this.urlData.md_id}`
        );
      }
    },
    // pwa初始化
    pwainit: function () {
      let _this = this; // addEventListener中事件函数的this指向的是它自己的内部
      if ("serviceWorker" in navigator) {
        // load 事件完成之后才注册 service worker
        window.addEventListener("load", function () {
          // 注册 sw
          navigator.serviceWorker
            .register(`${process.env.BASE_URL}/service-worker.js`)
            .then((registration) => {
              // 注册成功
              console.log("sw 注册成功", registration.scope);
            })
            .catch((err) => {
              // 注册失败:(
              console.log("sw 注册失败 ", err);
            });
        });
        window.addEventListener("beforeinstallprompt", function (e) {
          // 注册 sw.js
          e.preventDefault();
          _this.savePrompt = e;
          _this.downpwa = true;
        });
        window.addEventListener("appinstalled", () => {
          // 安装成功之后回调
          _this.downpwa = false;
          console.log("已安装到桌面屏幕");
          _this.$Storage.localStorageSet("cs", "true");
          console.log("window.location.search", window.location.search);
          _this.$Storage.localStorageSet(
            "installedFrom",
            window.location.search
          );
          if (this.system === "PC") {
            this.$Report.webDotFather(
              this.urlData.pid,
              this.urlData.appid,
              this.urlData.ukey,
              "install_pcldy_pwa_success"
            );
          } else {
            this.$Report.webDotFather(
              this.urlData.pid,
              this.urlData.appid,
              this.urlData.ukey,
              "install_moldy_pwa_success"
            );
          }
        });
        // chrome 浏览器判断
        if (window.matchMedia("(display-mode: standalone)").matches) {
          // 已经安装的启动方式
          _this.downpwa = false;
          console.log("display-mode 是 standalone");
        }
        // Safari 判断：
        console.log(
          "window.navigator.standalone Safari 判断",
          window.navigator.standalone
        );
        if (this.system == "PC") {
          if (window.navigator.standalone === true) {
            // 安装程序启动的时候，页面每次刷新会执行
            _this.downpwa = false;
            console.log("display-mode 是 standalone");
          }
        }
      }
    },
    // 客服同步登陆
    kfSync() {
      let access_token = this.$Storage.localStorageGet("access_token");
      console.log("客服同步登陆", access_token);
      let data = {
        ts: new Date().getTime(),
        cch_id: this.urlData.pid,
        app_id: this.urlData.appid,
        access_token: access_token,
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.sign = RSSign(data, data.app_id);
      this.$SyModel.kfSync(this.apiUrl.service.sync, data).then((res) => {
        console.log("客服", res);
        if (res.code == 200) {
          let kfUrl = this.$Storage.localStorageGet("kfUrl");
          let serviceUinfo = this.$Storage.localStorageGet("serviceUinfo");
          let lang = this.$Storage.localStorageGet("lang");
          let system = this.$Base.checkSysteam();

          // 获取操作系统信息
          const ua = navigator.userAgent;
          let os = "PC";
          let osVer = "";
          let deviceBrand = "";
          let deviceModel = "";

          if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
            os = "iOS";
            const match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (match)
              osVer =
                match[1] + "." + match[2] + (match[3] ? "." + match[3] : "");
            deviceBrand = "Apple";
            deviceModel = ua.match(/\(([^)]+)\)/)?.[1] || "";
          } else if (/Android/i.test(ua)) {
            os = "Android";
            const match = ua.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))?/);
            if (match)
              osVer =
                match[1] +
                (match[2] ? "." + match[2] : "") +
                (match[3] ? "." + match[3] : "");
            deviceBrand = ua.match(/Android.*?;\s*([^;\s]+)/)?.[1] || "";
            deviceModel = deviceBrand;
          } else {
            // PC端
            os = "windows";
            osVer = navigator.platform || "";
            deviceBrand = "";
            deviceModel = "";
          }

          // 基础URL参数
          const tm = new Date().getTime();
          let kefuParams =
            "?iframe=1&fromWeb=1&come_from=3&language=" +
            lang +
            "&uinfo=" +
            serviceUinfo +
            "&app_id=" +
            this.urlData.appid +
            "&cch_id=" +
            this.urlData.pid +
            "&md_id=" +
            this.urlData.md_id +
            "&time_zone=" +
            encodeURIComponent(this.$Base.timeZone()) +
            "&device_id=" +
            this.$Storage.localStorageGet("deviceIdUa") +
            "&access_token=" +
            access_token +
            "&sdk_type=en" +
            "&sdk_ver=" +
            this.$Base.sdkVer() +
            "&app_ver=" +
            this.$Base.getVersion() +
            "&tm=" +
            tm +
            "&net=" +
            (system === "MOBILE" ? "WIFI" : "PC") +
            "&os=" +
            os +
            "&os_ver=" +
            encodeURIComponent(osVer);

          // 添加设备信息参数
          if (deviceBrand) {
            kefuParams += "&device_brand=" + encodeURIComponent(deviceBrand);
          }
          if (deviceModel) {
            kefuParams += "&device_model=" + encodeURIComponent(deviceModel);
          }

          // 添加角色信息参数（如果存在）
          if (window.Role) {
            const role = window.Role;
            if (role.roleId) kefuParams += "&role_id=" + role.roleId;
            if (role.roleLevel) kefuParams += "&role_level=" + role.roleLevel;
            if (role.roleName)
              kefuParams += "&role_name=" + encodeURIComponent(role.roleName);
            if (role.serverId) kefuParams += "&sid=" + role.serverId;
            if (role.serverName)
              kefuParams += "&sname=" + encodeURIComponent(role.serverName);
            if (role.rolePay !== undefined) {
              kefuParams += "&role_pay=" + role.rolePay;
              kefuParams += "&account_pay=" + role.rolePay;
            }
          }

          this.kefuUrl = kfUrl + kefuParams;
          this.isKeFu = true;
        } else {
          this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          this.logoutLoginData();
        }
      });
    },
    // 个人信息
    userInfo(token) {
      let access_token = this.$Storage.localStorageGet("access_token");
      let data = {
        ts: new Date().getTime(),
        cch_id: this.urlData.pid,
        app_id: this.urlData.appid,
        token: token,
        sys_language: this.$Storage.localStorageGet("lang"),
        uinfo: access_token,
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .userInfo(this.apiUrl.user.user_extra_info, data)
        .then((res) => {
          if (res.code == 200) {
            this.personal = res.data;
            this.uid = res.data.uid;
            this.dataCollecInfo.uid = this.uid;
            this.dataCollecInfo.username = res.data.username;
          }
        })
        .catch((err) => {
          this.$Report.webErrorlogFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            err.msg,
            "個人信息接口"
          );
        });
    },
    // 校验邮箱或者帳號是否绑定
    verifyBindEmailA(token) {
      if (this.email !== "") {
        let uinfoData = {
          bind_v: this.email,
          bind_type: 4,
          type: "bind",
        };
        let data = {
          ts: new Date().getTime(),
          cch_id: this.urlData.pid,
          app_id: this.urlData.appid,
          token: token,
          sys_language: this.$Storage.localStorageGet("lang"),
          time_zone: this.$Base.timeZone(),
          nonce: this.$Base.nonce(12),
          sdk_ver: this.$Base.sdkVer(),
          version: this.$Base.getVersion(),
        };
        data.uinfo = this.$Ciphertext.AESkey(uinfoData);
        data.sign = RSSign(data, data.app_id);
        this.$SyModel
          .verifyBindEmailA(this.apiUrl.user.verify_bind_email, data)
          .then((res) => {
            // 返回 200 是已经绑定，201是没有绑定
            if (res.code == 2002) {
              this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            } else if (res.code == 2502) {
              // 請輸入正確的郵箱地址
              this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            } else if (res.code == 2503) {
              // 請輸入正確的郵箱地址
              this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            } else {
              this.$generalMethod
                .freezetoken(
                  this.urlData.pid,
                  this.urlData.appid,
                  this.urlData.md_id
                )
                .then((res) => {
                  if (res.code == 200) {
                    this.emailIndex(res.data);
                  }
                });
            }
          });
      } else {
        this.$toast(this.$t.message.input_bind_email);
        return;
      }
    },

    // 发送验证码接口方法
    emailIndex(token) {
      let uinfoData2 = {
        email: this.email,
        type: "bind",
      };
      let data = {
        ts: new Date().getTime(),
        cch_id: this.urlData.pid,
        app_id: this.urlData.appid,
        token: token,
        sys_language: this.$Storage.localStorageGet("lang"),
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData2);
      data.sign = RSSign(data, data.app_id);

      this.$SyModel
        .sendEmailCode(this.apiUrl.user.send_email, data)
        .then((res) => {
          if (res.code == 200) {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            this.$toast(errorMsg);
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            // 邮件已发送或者别的状态
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          }
        })
        .catch((err) => {
          this.$Report.webErrorlogFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            err.msg,
            "校验邮箱或者帳號是否绑定"
          );
        });
    },
    // 发送邮箱邮箱验证码
    sendEmailCode() {
      if (this.email !== "") {
        this.$generalMethod
          .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
          .then((res) => {
            if (res.code == 200) {
              this.verifyBindEmailA(res.data);
            }
          });
      } else {
        this.$toast(this.$t.message.input_bind_email);
        return;
      }
    },
    bindEmailBtn() {
      if (this.email !== "" && this.code !== "") {
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_email_blind"
          );
        } else {
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_moldy_email_blind"
          );
        }
        this.$generalMethod
          .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
          .then((res) => {
            if (res.code == 200) {
              this.bindEmail(res.data);
            }
          });
      }
    },
    // 绑定邮箱
    bindEmail(token) {
      let uname = this.$Storage.localStorageGet("apiUname");
      // let pwd = this.$Storage.localStorageGet("apiPwd");
      let uinfoData = {
        bind_v: this.email,
        vcode: this.code,
        bind_type: 4,
        uid: this.uid,
        uname: uname,
        pwd: this.$Storage.localStorageGet("apiPwd"),
      };
      let data = {
        ts: new Date().getTime(),
        cch_id: this.urlData.pid,
        app_id: this.urlData.appid,
        md_id: this.urlData.md_id,
        sys_language: this.$Storage.localStorageGet("lang"),
        token: token,
        btype: "Email",
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .bindEmail(this.apiUrl.user.verify_bind_third, data)
        .then((res) => {
          if (res.code == 200) {
            this.isPop = 0;
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            this.$toast(errorMsg);
            if (this.system === "PC") {
              this.$Report.webDotFather(
                this.urlData.pid,
                this.urlData.appid,
                this.urlData.ukey,
                "blind_email_success"
              );
            } else {
              this.$Report.webDotFather(
                this.urlData.pid,
                this.urlData.appid,
                this.urlData.ukey,
                "blind_moldy_email_success"
              );
            }
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            this.$toast(errorMsg);
          }
        })
        .catch((err) => {
          this.$Report.webErrorlogFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            err.msg,
            "綁定郵箱接口"
          );
        });
    },
    // 退出登陆
    logoutLoginData() {
      // window.localStorage.clear();
      window.localStorage.removeItem("apiPwd");
      window.localStorage.removeItem("show");
      window.localStorage.removeItem("apiUname");
      window.localStorage.removeItem("_XH_U_WEBSDK");
      window.localStorage.removeItem("serviceUinfo");
      window.localStorage.removeItem("access_token");
      window.localStorage.removeItem("regId");
      this.$Storage.delCookie();
      if (this.system === "PC") {
        window._hmt.push(["_trackEvent", "click", "click_pcmsr_quit"]);
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_pcmsr_quit"
        );
      } else {
        window._hmt.push(["_trackEvent", "click", "click_momsr_quit"]);
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "click_momsr_quit"
        );
      }
      this.personal = "";
      // 成功跳转
      window.location.href = `/global/ldy/fzg?ukey=${this.urlData.ukey}&appid=${this.urlData.appid}&pid=${this.urlData.pid}&md_id=${this.urlData.md_id}`;
    },
    // 获取游戏地址
    getGameUrl() {
      this.$generalMethod
        .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
        .then((res) => {
          if (res.code == 200) {
            let data = {
              ts: new Date().getTime(),
              cch_id: this.urlData.pid,
              app_id: this.urlData.appid,
              token: res.data,
              sys_language: this.$Storage.localStorageGet("lang"),
              nonce: this.$Base.nonce(12),
              sdk_ver: this.$Base.sdkVer(),
              version: this.$Base.getVersion(),
              access_token: this.$Storage.localStorageGet("access_token"),
              // 这个只是为了在测试环境下能拿到信息测试，正式环境是不需要的，成功成功那里也要记得去掉
              // uinfo: this.$Storage.localStorageGet("_XH_U_WEBSDK") || ''
            };
            data.sign = RSSign(data, data.app_id);
            this.$SyModel
              .getGameUrl(this.apiUrl.user.enter, data)
              .then((res) => {
                if (res.code == 200) {
                  this.$Storage.localStorageSet(
                    "access_token",
                    res.data.access_token
                  );
                  this.$Storage.localStorageSet("linkUrl", this.gameUrl);
                  let deviceld = this.$Storage.localStorageGet("deviceIdUa");
                  this.gameUrl = `${res.data.uri}?pid=${this.urlData.pid}&appid=${this.urlData.appid}&md_id=${this.urlData.md_id}&access_token=${res.data.access_token}&deviceld=${deviceld}`;
                  this.loadiframe();
                } else {
                  this.$toast(res.msg.replace(/\[.*?\]/g, ""));
                  this.logoutLoginData();
                }
              })
              .catch((err) => {
                this.$Report.webErrorlogFather(
                  this.urlData.pid,
                  this.urlData.appid,
                  this.urlData.ukey,
                  err.msg,
                  "獲取遊戲地址"
                );
              });
          }
        });

      // let data = {
      //   ts: new Date().getTime(),
      //   cch_id: this.urlData.pid,
      //   app_id: this.urlData.appid,
      //   nonce: this.$Base.nonce(12),
      //   version: this.$Base.getVersion(),
      //   sdk_ver: this.$Base.sdkVer(),
      //   // 这个只是为了在测试环境下能拿到信息测试，正式环境是不需要的，成功成功那里也要记得去掉
      //   // uinfo: this.$Storage.localStorageGet("_XH_U_WEBSDK") || ''
      // };
      // data.sign = RSSign(data, data.app_id);
      // this.$SyModel
      //   .getGameUrl(this.apiUrl.user.enter, data)
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.$Storage.localStorageSet(
      //         "access_token",
      //         res.data.access_token
      //       );
      //       this.$Storage.localStorageSet("linkUrl", this.gameUrl);
      //       let deviceld = this.$Storage.localStorageGet("deviceIdUa");
      //       this.gameUrl = `${res.data.uri}?pid=${this.urlData.pid}&appid=${this.urlData.appid}&md_id=${this.urlData.md_id}&access_token=${res.data.access_token}&deviceld=${deviceld}`;
      //       this.loadiframe();
      //     } else {
      //       this.$toast(res.msg.replace(/\[.*?\]/g, ""));
      //       this.logoutLoginData();
      //     }
      //   })
      //   .catch((err) => {
      //     this.$Report.webErrorlogFather(
      //       this.urlData.pid,
      //       this.urlData.appid,
      //       this.urlData.ukey,
      //       err.msg,
      //       "獲取遊戲地址"
      //     );
      //   });
    },
    // 刷新游戏链接
    pageRefresh() {
      this.gameUrl = "";
      this.getGameUrl();
    },
    // 判断游戏加载是否完成
    loadiframe() {
      console.log("onload");
      var cs = true;
      var _this = this;
      if (this.$refs.gameIframe.attachEvent) {
        this.$refs.gameIframe.attachEvent("onload", function () {
          if (cs) {
            console.log("onload1");
            _this.showModule();
            if (this.system === "PC") {
              _this.$Report.webDotFather(
                _this.urlData.pid,
                _this.urlData.appid,
                _this.urlData.ukey,
                "show_pcldy_guide"
              );
            } else {
              _this.$Report.webDotFather(
                _this.urlData.pid,
                _this.urlData.appid,
                _this.urlData.ukey,
                "show_moldy_guide"
              );
            }
            cs = false;
          }
        });
      } else {
        this.$refs.gameIframe.onload = function () {
          if (cs) {
            console.log("onload2");
            _this.showModule();
            if (this.system === "PC") {
              _this.$Report.webDotFather(
                _this.urlData.pid,
                _this.urlData.appid,
                _this.urlData.ukey,
                "show_pcldy_guide"
              );
            } else {
              _this.$Report.webDotFather(
                _this.urlData.pid,
                _this.urlData.appid,
                _this.urlData.ukey,
                "show_moldy_guide"
              );
            }
            cs = false;
          }
        };
      }
    },
    // 倒计时显示/隐藏相关弹窗
    showModule() {
      if (this.entryTime == 0) {
        this.showModuletime = setInterval(() => {
          this.entryTime = this.entryTime + 1;
          if (this.entryTime >= 10) {
            this.isDialog = true;
          }
          if (this.entryTime >= 40) {
            this.isDialog = false;
            clearInterval(this.showModuletime);
          }
        }, 1000);
      }
    },
    // 消息获取
    async saveMessage(res) {
      let data = res.data;
      let action = data.action;
      let info = data.info;
      switch (action) {
        case "RaStarShowProtocol": {
          this.$refs.protocol.show();
          break;
        }
        case "RaStarGetRegion": {
          console.log("RaStarGetRegion");
          this.$refs.gameIframe.contentWindow.postMessage(
            {
              action: "onRegionSelected",
              info: localStorage.getItem("selected_region"),
            },
            "*"
          );
          break;
        }
        case "RaStarPay": {
          console.log("RaStarPay");
          const createOrder = () => {
            RastarSdk.createOrder(info, this.urlData, this.apiUrl.pay).then(
              (res) => {
                console.log(res);

                if (res == 6004) {
                  console.log(res);
                  this.$refs.verifiedUsa.check().then(() => {
                    console.log("try create order again");
                    createOrder();
                  });
                  return;
                }
                if (res == 6005) {
                  this.$refs.verifiedUsa.fail(
                    this.$t("message.payFailedMessage")
                  );
                  return;
                }
                this.payUrl = res;
                this.$refs.gameIframe.contentWindow.postMessage(
                  {
                    action: "onPaySuccess",
                    info: res,
                  },
                  "*"
                );
              }
            );
          };
          createOrder();
          break;
        }
        case "RaStarUpload":
          await RastarSdk.RaStarUpload(info, this.urlData, this.dataCollecInfo);
          break;
        case "RaStarCloseService":
          await this.kefuColse();
          break;
        case "RaStarClosePay":
          await this.zhifuColse();
          break;
        case "RaStarGoBack":
          console.log("执行RaStarGoBack");
          await this.getNewinfo();
          break;
        case "RaStarRefresh":
          await this.pageRefresh();
          break;
      }
    },
    // 获取礼包码token
    giftsToken() {
      this.$generalMethod
        .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
        .then((res) => {
          if (res.code == 200) {
            this.gifts(res.data);
          }
        });
    },
    // 判断是否显示礼包码
    gifts(token) {
      let uinfo = this.$Storage.localStorageGet("_XH_U_WEBSDK");
      let data = {
        ts: new Date().getTime(),
        cch_id: this.urlData.pid,
        app_id: this.urlData.appid,
        nonce: this.$Base.nonce(12),
        version: this.$Base.getVersion(),
        sdk_ver: this.$Base.sdkVer(),
        token: token,
        uinfo: uinfo,
      };
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .verifyBindEmailA(this.apiUrl.gift.gift_enter, data)
        .then((res) => {
          if (res.code == 200) {
            this.isGetGift = res.data.is_show;
            if (this.isGetGift == true) {
              if (this.system === "PC") {
                this.$Report.webDotFather(
                  this.urlData.pid,
                  this.urlData.appid,
                  this.urlData.ukey,
                  "show_pcldy_download_tips"
                );
              } else {
                this.$Report.webDotFather(
                  this.urlData.pid,
                  this.urlData.appid,
                  this.urlData.ukey,
                  "show_moldy_download_tips"
                );
              }
            }
          } else {
            console.log(res.data);
          }
        });
    },
    // 获取礼包码
    getgiftCode() {
      this.$generalMethod
        .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
        .then((res) => {
          if (res.code == 200) {
            let uinfo = this.$Storage.localStorageGet("_XH_U_WEBSDK");
            let data = {
              ts: new Date().getTime(),
              cch_id: this.urlData.pid,
              app_id: this.urlData.appid,
              nonce: this.$Base.nonce(12),
              version: this.$Base.getVersion(),
              sdk_ver: this.$Base.sdkVer(),
              uinfo: uinfo,
              token: res.data,
            };
            data.sign = RSSign(data, data.app_id);

            this.$SyModel
              .verifyBindEmailA(this.apiUrl.gift.gift_code, data)
              .then((res) => {
                if (res.code == 200) {
                  this.giftCode = res.data.gift_code;
                  if (this.giftCode) {
                    this.isGift = true;
                    if (this.system === "PC") {
                      this.$Report.webDotFather(
                        this.urlData.pid,
                        this.urlData.appid,
                        this.urlData.ukey,
                        "show_pcldy_copy_gift_window"
                      );
                    } else {
                      this.$Report.webDotFather(
                        this.urlData.pid,
                        this.urlData.appid,
                        this.urlData.ukey,
                        "show_moldy_copy_gift_window"
                      );
                    }
                  } else {
                    this.isNullgift = true;
                  }
                } else {
                  console.log(res.data);
                }
              });
          }
        });
    },
  },
  created() {
    // 把页面链接存起来支付的时候需要调用
    this.$Storage.setCookie("msrGameUrl", window.location.href, 7);
    window.addEventListener("resize", this.getHeight); // 注册监听器
    this.getHeight(); // 页面创建时先调用一次
    this.system = this.$Base.checkSysteam();
    this.navigatorAAll();
    if (this.system == "PC") {
      const installedFrom = this.$Storage.localStorageGet("installedFrom");
      if (installedFrom && this.$Storage.localStorageGet("cs") == "true") {
        this.$Storage.localStorageSet("cs", "false");
        window.location.href = window.location.pathname + installedFrom;
      } else {
        this.$Storage.localStorageSet("cs", "true");
      }
    }
    this.urlData = this.$Base.parseUrl(window.location.href);
    if (this.urlData.ukey.length != 32) {
      alert(this.$t.message.urlError);
      return;
    }
    // 用户信息
    if (!this.XHUWEBSDK) {
      console.log("未登录");
      window.location.href = `/global/ldy/fzg?ukey=${this.urlData.ukey}&appid=${this.urlData.appid}&pid=${this.urlData.pid}&md_id=${this.urlData.md_id}`;
    } else {
      console.log("deviceIdUa 存在");
      this.$generalMethod
        .freezetoken(this.urlData.pid, this.urlData.appid, this.urlData.md_id)
        .then((res) => {
          if (res.code == 200) {
            this.userInfo(res.data);
          }
        });
    }
    this.getGameUrl();
    let bingshow = this.$Storage.localStorageGet("show");
    if (bingshow == 1) {
      this.$Storage.localStorageSet("show", "0");
      if (this.system === "PC") {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "show_email_blind_index"
        );
      } else {
        this.$Report.webDotFather(
          this.urlData.pid,
          this.urlData.appid,
          this.urlData.ukey,
          "show_moldy_email_blind_index"
        );
      }
      this.isPop = 3;
    }
    // 定时器弹出
    let regId = this.$Storage.localStorageGet("regId");
    if (regId == 1 && this.system == "PC") {
      this.$Storage.localStorageSet("regId", "0");
      setTimeout(this.isColl, 170000);
    }
  },
  mounted() {
    // 根据不同语言添加class
    this.isActiveClass();
    this.pwainit();
    this.giftsToken();
    // 客服是否有消息
    this.getNewinfo();
    // 暴露方法到window
    window.addEventListener("message", this.saveMessage, false);
  },
};
</script>
<style lang="scss" src="./style.scss" scoped></style>
<style>
@keyframes dialog-appearance {
  from {
    transform: scale(0.8);
  }

  to {
    transform: scale(1);
  }
}
</style>
